export class BindingManager {
  Id: number;
  Name: string;
  IsSelected: boolean;
  constructor(Id: number, Name: string, IsSelected: boolean) {
    this.Id = Id;
    this.Name = Name;
    this.IsSelected = IsSelected;
  }
}
